import { Alert, Platform, type AlertButton, type AlertOptions } from 'react-native';

const joinMessage = (title?: string, description?: string) =>
  [title, description].filter(Boolean).join('\n');

/**
 * Web のときは window.alert/confirm にフォールバック。
 * ネイティブのときは Alert.alert をそのまま使います。
 */
const alertPolyfill = (
  title?: string,
  description?: string,
  options?: AlertButton[],
  extra?: AlertOptions,
) => {
  // Web 以外（window 未定義）なら RN の Alert に委譲
  if (typeof window === 'undefined') {
    Alert.alert(title ?? '', description ?? '', options, extra);
    return;
  }

  // ボタン未指定 → 単純アラート
  if (!options || options.length === 0) {
    window.alert(joinMessage(title, description));
    return;
  }

  const msg = joinMessage(title, description);

  // OK 側：style !== "cancel" を優先、無ければ先頭
  const okBtn = options.find((o) => o.style !== 'cancel') ?? options[0];
  // Cancel 側：style === "cancel"
  const cancelBtn = options.find((o) => o.style === 'cancel');

  const ok = window.confirm(msg);
  if (ok) {
    okBtn?.onPress?.();
  } else {
    cancelBtn?.onPress?.();
  }
};

const alert = Platform.OS === 'web' ? alertPolyfill : Alert.alert;

export default alert;
